import React from 'react';

const Logo = ({ size = 'medium', className = '', showText = true }) => {
  const sizeClasses = {
    small: 'h-6',
    medium: 'h-8', 
    large: 'h-12',
    xl: 'h-24',  // Triple the medium size (8 * 3 = 24)
    hero: 'h-32',  // Prominent size for main pages
    giant: 'h-64'  // Really visible size for sign-in screen
  };

  // For small sizes or when showText is false, use icon-only logo
  // For larger sizes with text, use full logo with text
  const useIconOnly = size === 'small' || !showText;

  // Use environment variables for logo URLs with fallbacks
  const logoIconUrl = process.env.REACT_APP_LOGO_ICON_URL || 
    'https://customer-assets.emergentagent.com/job_carcare-buddy-1/artifacts/4tye5ila_ChatGPT%20Image%20Sep%2028%2C%202025%2C%2009_35_18%20AM.png';
  
  const logoFullUrl = process.env.REACT_APP_LOGO_FULL_URL || 
    'https://customer-assets.emergentagent.com/job_carcare-buddy-1/artifacts/dqs1qpc0_ChatGPT%20Image%20Sep%2028%2C%202025%2C%2009_33_37%20AM.png';
  
  const logoSrc = useIconOnly ? logoIconUrl : logoFullUrl;

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoSrc}
        alt="Track My Garage Logo"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;